import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import Goal from '../images/goal.svg'
import Games from '../images/games.svg'
import Keeper from '../images/keeper.svg'
import Streak from '../images/streak.svg'
import Penalty from '../images/penalty.svg'

console.log()

function TeamsCard() {
  let { id } = useParams()
  let { idleague } = useParams()
  const [teamData, setTeamData] = useState([])
  const [teamStats, setTeamStats] = useState({})
  const [view, setView] = useState(false)

  useEffect(() => {
    console.log('hig' + id)
    console.log('ghgyg' + idleague)
    fetchTeam(idleague, id)
  }, [])

  const fetchTeam = (idleague, id) => {
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '42b487df01msh9367a40af1580cap17dd76jsn8040671db253',
        'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com',
      },
    }

    fetch(
      `https://api-football-v1.p.rapidapi.com/v3/teams/statistics?league=${idleague}&season=2022&team=${id}`,
      options
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
        setTeamStats(response.response)
      })
      .catch((err) => console.error(err))

    fetch(`https://api-football-v1.p.rapidapi.com/v3/teams?id=${id}`, options)
      .then((response) => response.json())
      .then((response) => {
        setTeamData(response.response)
      })
      .catch((err) => console.error(err))
  }

  return (
    <div className=''>
      {teamData.map((item) => {
        return (
          <>
            <section className=' '>
              <div className='grid grid-cols-1 md:grid-cols-2  mx-auto pt-32  w-5/6 my-auto  font-arvo font-medium  '>
                <div className=' text-white   min-h-[350px] '>
                  <div className=' h-1/2 '>
                    <div className=' h-full flex'>
                      <div className='w-2/5 flex items-center justify-end'>
                        <img className=' h-[100px]' src={item.team.logo} />
                      </div>

                      <div className='w-3/5 flex flex-col justify-center items-start ml-2'>
                        <h1 className=' text-black'>f.c</h1>
                        <h1 className=' text-black  text-3xl'>
                          {item.team.name}
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div className=' h-1/2'>
                    <div className='w-5/6 h-5/6  mx-auto my-auto mt-2'>
                      <div className=' h-1/3 border-t-2 border-t-gray-300 '>
                        <div className='flex  h-full'>
                          <div className='w-1/3 h-full text-gray-400 flex items-center ml-1 text-sm '>
                            Country
                          </div>
                          <div className='w-2/3 h-full text-black flex justify-end items-center mr-1'>
                            {item.team.country}
                          </div>
                        </div>
                      </div>

                      <div className=' h-1/3 border-t-2 border-t-gray-300 '>
                        <div className='flex  h-full'>
                          <div className='w-1/3 h-full text-gray-400 flex items-center ml-1 text-sm'>
                            Founded
                          </div>
                          <div className='w-2/3 h-full text-black flex justify-end items-center mr-1'>
                            {item.team.founded}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=' py-10 border-t-2 border-black md:border-l-2 md:border-t-white  border-black  md:order-last'>
                  <div className=' flex justify-center  '>
                    <img
                      className='h-[150px] w-[250px]'
                      src={item.venue.image}
                    />
                  </div>
                  <div className='border-y-2  border-gray-300 flex mt-6 justify-center w-5/6 mx-auto py-2'>
                    <h3 className='text-lg'>{item.venue.name}</h3>
                  </div>
                </div>
              </div>
            </section>
          </>
        )
      })}
      <div className=' w-full  mt-8 flex justify-center'>
        {
          <button
            class='bg-violet-400 hover:bg-violet-700 text-white font-bold py-2 px-4 rounded mx-auto'
            onClick={() => setView(!view)}
          >
            {view ? 'Unshow stats' : 'Show Stats'}
          </button>
        }
      </div>
      {view && (
        <>
          <section className=' mt-12 h-[300px] w-5/6 mx-auto  '>
            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pb-12'>
              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.goals?.for?.average?.total}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Games} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>GPG</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.goals?.for?.total?.total}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Goal} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Goals For</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.fixtures?.played?.total}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Games} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Total Games</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.clean_sheet?.total}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Keeper} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Clean Sheets</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.penalty?.scored?.total}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Goal} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Penaltys</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.biggest.streak.wins}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Streak} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Streak Wins</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.goals?.against?.total?.total}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Goal} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Goals Against</h1>
                  </div>
                </div>
              </div>

              <div className='min-w-[70px] min-h-[250px] bg-gray-200 rounded-xl '>
                <div className='h-2/5 mt-10 rounded-full border-t-2 border-b-2 border-b-gray-200 border-black w-4/6 mx-auto py-10  flex items-center justify-center'>
                  <div className=' text-4xl'>
                    {teamStats?.biggest.streak.loses}
                  </div>
                </div>
                <div className='  h-2/5 '>
                  <div className='  flex justify-center '>
                    <img className=' w-12 h-12' src={Streak} />
                  </div>
                  <div className=' flex justify-center mt-2'>
                    <h1 className='text-xl lg:text-3xl'>Streak Loses</h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  )
}

export default TeamsCard
